import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { FavoriteButton } from 'shared/components/NewbuildingDecorations/parts/FavoriteButton';

import { getIsFavorite } from '../../../selectors';
import { changeFavoriteAction } from '../../../store/offer';

export const FavoriteButtonContainer: React.FC = () => {
  const dispatch = useDispatch();
  const isFavorite = useSelector(getIsFavorite);
  /* istanbul ignore next */
  const changeFavorite = React.useCallback(() => dispatch(changeFavoriteAction()), []);

  return <FavoriteButton isFavorite={isFavorite} onClick={changeFavorite} theme={'fill_secondary'} />;
};
